interface ScoreGaugeProps {
  value: number;
  size?: number;
}

// Half-ring gauge with cyan glow.
export function ScoreGauge({ value, size = 56 }: ScoreGaugeProps): JSX.Element {
  const r = size / 2 - 4;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value)) / 100;
  const dash = c * pct;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="-rotate-90">
      <defs>
        <linearGradient id="gauge" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#22D3EE" />
          <stop offset="100%" stopColor="#84CC16" />
        </linearGradient>
        <filter id="gauge-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="2" result="coloredBlur" />
          <feMerge>
            <feMergeNode in="coloredBlur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke="#1F2940"
        strokeWidth="4"
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        stroke="url(#gauge)"
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
        strokeDasharray={`${dash} ${c}`}
        filter="url(#gauge-glow)"
      />
    </svg>
  );
}
